import { useDashboards } from '../../context';
import { DashboardsCategory } from './dashboards-category.component';
import { DashboardsTableau } from './dashboards-tableau.component';

export const DashboardsWorkbooks = () => {
  const { dashboardWorkbooksQuery, selectedCategory, selectedWorkbook } =
    useDashboards();

  return (
    <>
      {selectedCategory && !selectedWorkbook && <DashboardsCategory />}

      {dashboardWorkbooksQuery.data && selectedWorkbook && (
        <DashboardsTableau />
      )}
    </>
  );
};
